import { useState } from "react";

import { Button } from "@fronterahealth/frontera-ui-components/ui/button";
import {
  InputGroup,
  InputGroupButton,
  InputGroupTextarea,
} from "@fronterahealth/frontera-ui-components/ui/input-group";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { submitOrCancelOnKey } from "@components/QaReview/components/commentKeyboard";
import { useEditComment } from "@components/QaReview/hooks/useEditComment";

interface CommentEditorProps {
  comment: ReviewItemFieldsFragment;
  onDone: () => void;
}

export const CommentEditor: React.FC<CommentEditorProps> = ({ comment, onDone }) => {
  const { edit, isPending } = useEditComment();
  const [draft, setDraft] = useState(comment.content ?? "");

  const body = draft.trim();
  const canSave = !!body && body !== comment.content && !isPending;

  const save = () => {
    if (canSave) edit(comment, body, onDone);
  };

  return (
    <div className="space-y-2">
      <InputGroup onClick={(e) => e.stopPropagation()}>
        <InputGroupTextarea
          aria-label="Edit comment"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={submitOrCancelOnKey(save, onDone)}
          rows={2}
          autoFocus
        />
        {/* The group centers its items; mt-2 matches the textarea's py-2 so Save lines up with the first line. */}
        <InputGroupButton className="mt-2 self-start" onClick={save} disabled={!canSave}>
          Save
        </InputGroupButton>
      </InputGroup>
      <Button
        variant="ghost"
        size="xs"
        onClick={(e) => {
          e.stopPropagation();
          onDone();
        }}
      >
        Cancel
      </Button>
    </div>
  );
};
